import { Radio as AntdRadio } from 'antd';
import styled from 'styled-components';

export const Radio = styled(AntdRadio)(({ theme }) => ({
  color: theme.palette.erieBlack,
}));
